<ngx-spinner bdColor="rgb(63,69,95)" size="medium" color=" #0af0d5" type="ball-scale-pulse" [fullScreen]="true" [zIndex]="5000">
  <p style="text-align: center; color: #fff;">If the page does not load in 10 seconds, please refresh the page.</p>

</ngx-spinner>
